import { XSTEP_MINT } from "@stepfinance/common";

import { useMarkets } from "../../contexts/market";
import { cache } from "../../utils/cache";
import { useAccountByMint } from "./useAccountByMint";

export const STAKED_ACCESS_REQUIRED_XSTEP_USD = 250;

export const useUserStakedAccess = () => {
  const { priceInUSD } = useMarkets();
  const xStepAccount = useAccountByMint(XSTEP_MINT);
  const xStepMint = cache.getMint(XSTEP_MINT);
  const xStepPrice = priceInUSD(XSTEP_MINT.toBase58());
  // Use a minimum price of 10 cents if price not available
  const requiredXStep = STAKED_ACCESS_REQUIRED_XSTEP_USD / (xStepPrice === null || xStepPrice <= 0 ? 0.1 : xStepPrice);

  if (xStepAccount && xStepMint && xStepAccount.tokenAmount.uiAmount > requiredXStep) {
    return true;
  }

  return false;
};
